export const calendar = require('./calendar-31-mid.svg');
export const clock = require('./clock-hi-dark.svg');
export const home = require('./home-mid.svg');
export const bell = require('./9411_notifications-mid_AdditionalFile.svg');
export const mail = require('./mail-new-mid.svg');
export const vodafoneIcon = require('./vodafoneIcon.svg');
export const admin = require('./10_Admin_Elias.svg')
export const admintoolbox = require('./toolBox.svg')
export const cableImage = require("./background.png");
export const ticketImage = require("./ticket.png");
export const errorImage = require("./error.png");
export const icon = require('./favicon.ico');
